import * as types from './actionTypes';

const initialState = {
  positions: [],
  skillMappings: [],
  filteredPositions: [],
  competencyList: [],
  loading: false,
  error: null,
  success: false,
};

const positionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_POSITIONS_REQUEST:
    case types.FETCH_SKILL_MAPPING_REQUEST:
    case types.FETCH_POSITIONS_BY_DEPT_ROLE_REQUEST:
    case types.FETCH_COMPETENCY_LIST_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_POSITIONS_SUCCESS:
      return { ...state, loading: false, positions: action.payload.data || [] };

    case types.FETCH_SKILL_MAPPING_SUCCESS:
      return { ...state, loading: false, skillMappings: action.payload.data || [] };

    case types.FETCH_POSITIONS_BY_DEPT_ROLE_SUCCESS:
      return { ...state, loading: false, filteredPositions: action.payload.data || [] };

    case types.FETCH_COMPETENCY_LIST_SUCCESS:
      return { ...state, loading: false, competencyList: action.payload.data || [] };

    case types.FETCH_POSITIONS_FAILURE:
    case types.FETCH_SKILL_MAPPING_FAILURE:
    case types.FETCH_POSITIONS_BY_DEPT_ROLE_FAILURE:
    case types.FETCH_COMPETENCY_LIST_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case types.SAVE_POSITION_REQUEST:
    case types.CHANGE_POSITION_STATUS_REQUEST:
      return { ...state, error: null, success: false };

    case types.SAVE_POSITION_SUCCESS:
    case types.CHANGE_POSITION_STATUS_SUCCESS:
      return { ...state, success: true };

    case types.SAVE_POSITION_FAILURE:
    case types.CHANGE_POSITION_STATUS_FAILURE:
      return { ...state, error: action.payload, success: false };

    case types.SAVE_SKILL_MAPPING_REQUEST:
      return {
        ...state,
        error: null,
        success: false,
      };
    
    case types.SAVE_SKILL_MAPPING_SUCCESS:
      return {
        ...state,
        success: true,
      };
    
    case types.SAVE_SKILL_MAPPING_FAILURE:
      return {
        ...state,
        error: action.payload,
        success: false,
      };
    
    case types.CHANGE_SKILL_MAPPING_STATUS_REQUEST:
      return {
        ...state,
        error: null,
        success: false,
      };
    
    case types.CHANGE_SKILL_MAPPING_STATUS_SUCCESS:
      return {
        ...state,
        success: true,
      };
    
    case types.CHANGE_SKILL_MAPPING_STATUS_FAILURE:
      return {
        ...state,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default positionReducer;
